import { ApplicationInitStatus, APP_INITIALIZER, Component, HostListener, Inject, OnInit } from '@angular/core';
import { Settings, AppSettings } from './components/shared/services/color-option.service';
import { Router, NavigationEnd, ActivatedRoute, ActivationStart } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from './components/shared/services/config.service';
import { UserService } from './components/shared/services/user.service';
import { PersistentService } from './components/shared/services/persistent.service';
import { Cart1Service } from './components/shared/services/cart1.service';
import { ProductService } from './components/shared/services/product.service';
import { SideNavBarService } from './components/shared/services/sidenavbar.service';
import { CompanyService } from './components/shared/services/company.service';
import { NotificationService } from './components/shared/services/notification.service';
import { RestApiService } from './components/shared/services/restapi.service';
import { AccountService } from './components/shared/services/account.service';
import { UserServiceModal } from './modals/userservice.modal';
import { UtilityService } from './components/shared/services/utility.service';
import { AutoshipConfigurationService } from './components/shared/services/autoshipConfiguration.service';
import { getSubdomain } from 'tldts';
import { FreeEnrollmentItemID } from './constant';
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  public settings: Settings;
  public url: any;
  public counter: number;
  previousType: any;

  constructor(
    @Inject(APP_INITIALIZER) public appInit: ApplicationInitStatus,
    public configService: ConfigService,
    private dialog: MatDialog,
    public appSettings: AppSettings,
    public router: Router,
    private translate: TranslateService,
    public userService: UserService,
    public persistent: PersistentService,
    public cartsService: Cart1Service,
    private route: ActivatedRoute,
    public itemsService: ProductService,
    public sideNavBarService: SideNavBarService,
    public companyService: CompanyService,
    public notification: NotificationService,
    public apiService: RestApiService,
    private accountService: AccountService,
    public utilityService: UtilityService,
    public autoshipConfigurationService: AutoshipConfigurationService,
  ) {
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    if (sessionStorage.getItem("language")) {
      translate.setDefaultLang(sessionStorage.getItem("language"));
      translate.use(sessionStorage.getItem("language"));
    } else {
      translate.setDefaultLang("en");
      translate.use("en");
    }
    this.settings = this.appSettings.settings;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.url = event.url;
      }
    });
  }
  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    sessionStorage.setItem("userService", JSON.stringify(this.userService.userServiceModal));
    sessionStorage.setItem("retailData", JSON.stringify(this.persistent.retailData));
  }

  ngOnInit() {
    // Check for domain redirect
    this.checkDomainRedirect();
    
    this.route.queryParams.subscribe(params => {
      const SSOToken = params['SSOToken'];
      const ImpToken = params['ImpToken'];
      const CustomerID = params['CustomerID'];
      const returnUrl = params['returnUrl'] || null;

      if (!ImpToken && SSOToken && CustomerID) {
        this.loginFunction(CustomerID, SSOToken, 'sso', returnUrl);
      }
      if (!SSOToken && ImpToken && CustomerID) {
        this.loginFunction(CustomerID, ImpToken, 'impersonate', returnUrl);
      }
    });
    this.linkBuilderProduct_AddtoCart();
    document.documentElement.style.setProperty("--theme-deafult", "#FFA500");
    this.previousType = this.userService.userServiceModal.customerTypeID;
  }

  itemType: string;
  itemTypes = {
    pack: {
      getItemsCall: "GetEnrollmentKitItems",
      itemQuantity: "packQuantity",
      cartItems: "selectedPacks",
      itemserviceCall: "getPackItems",
    },
    order: {
      getItemsCall: "GetProducts",
      itemQuantity: "orderQuantity",
      cartItems: "selectedOrderItems",
      itemserviceCall: "getOrderItems",
    },
    autoship: {
      getItemsCall: "GetAutoshipItems",
      itemQuantity: "autoshipQuantity",
      cartItems: "selectedAutoOrderItems",
      itemserviceCall: "getAutoshipItems",
    },
  };

  itemsForCustomerIBO() {
    this.itemsService.getProduct(14).subscribe((p) => {
      //if length of selected initial items is not 0 then loops through cart to check item 14
      if (this.itemsService.selectedOrderItems.length != 0) {
        let alreadyinCart = false;
        this.itemsService.selectedOrderItems.forEach(item => {
          if (item.ItemID == FreeEnrollmentItemID) {
            alreadyinCart = true;
          }
        })
        if (!alreadyinCart) {
          this.cartsService.addToCart(p, false, "", false, false, false, true, false, this.counter);
        }
      }
      //if length of selected initial items is 0 then adds item 14 to cart
      else {
        this.cartsService.addToCart(p, false, "", false, false, false, true, false, this.counter);
      }
      //end
    });
  }

  itemsForCustomerPC() {
    this.itemsService.getProduct(23748).subscribe((p) => {
      if (this.itemsService.selectedOrderItems.length != 0) {
        let alreadyinCart = false;
        this.itemsService.selectedOrderItems.forEach(item => {
          if (item.ItemID == 23748) {
            alreadyinCart = true;
          }
        })
        if (!alreadyinCart) {
          this.cartsService.addToCart(p, false, "", false, false, false, true, false, this.counter);
        }
      }
      //if length of selected items is 0 then adds item 23748 to cart
      else {
        this.cartsService.addToCart(p, false, "", false, false, false, true, false, this.counter);
      }
      //end
    });
  }

  public addToCart(type, product: any, quantity) {
    this.currentQuantity(type, product, quantity);
    if (product) {
      product.Quantity = quantity;
      this.cartsService.addToCart(product, true, product.ItemID, type == "autoship", false, type == "pack", false, false, this.counter);
      sessionStorage.setItem("params.item", JSON.stringify(product));
    }
  }

  currentQuantity(type, item, quantity) {
    if (type && item && quantity) {
      type = type || this.itemType;
      this.cartsService[this.itemTypes[type].itemQuantity] =
        this.cartsService[this.itemTypes[type].itemQuantity] || {}; // TODO::check if needed
      this.cartsService[this.itemTypes[type].itemQuantity][item.ItemID] =
        quantity;
    } else {
      this.notification.error('error', 'Please try again')
    }
  }

  //Added for link builder product cart adding, functionality integrate
  private linkBuilderProduct_AddtoCart() {
    try {
      this.router.events.subscribe((event) => {
        if (event instanceof ActivationStart) {
          if (Object.keys(event.snapshot.queryParams).includes("products")) {
            let parameters = event.snapshot.queryParams;
            let customerType = parameters.type;
            this.userService.userServiceModal.selectedCountry = parameters.countrycode;
            this.userService.userServiceModal.selectedLanguageCode = parameters.language;
            this.userService.userServiceModal.customerTypeID = parseInt(customerType, 10);
            sessionStorage.setItem('userService', JSON.stringify(this.userService.userServiceModal));
            sessionStorage.setItem('selectedCountry', this.userService.userServiceModal?.selectedCountry);
            let items = JSON.parse(parameters.products);
            sessionStorage.setItem('linkbuilderITEMS', JSON.stringify(items));
            this.counter = 0;
            this.itemsService.getProductByCategory().subscribe((res) => {
              if (items.length > 0) {
                items.forEach((item) => {
                  this.counter += item.autoshipqty;
                  if (item.orderqty >= 1) {
                    this.counter += 1;
                  }
                });
              }
              if (items.length > 0 && (this.userService.userServiceModal.customerTypeID == 3 || this.userService.userServiceModal.customerTypeID == 1)) {
                this.counter = this.counter + 1;
              }
              if (parameters.products) {
                JSON.parse(parameters.products).forEach((item) => {
                  this.itemsService.getProduct(item.itemcode).subscribe((product) => {
                    // order quantity items
                    if (item.orderqty > 0) {
                      if (item.itemoptionid > 0) {
                        product.OptionsMap.every(element => {
                          if (parseInt(element.ItemId) == parseInt(item.itemoptionid)) {
                            product.ItemID = element.ItemId;
                            const key = element.Key;
                            product.selectedOptions = '[' + key.replaceAll('|', ',') + ']';
                            this.addToCart('order', product, item.orderqty);
                            sessionStorage.setItem('cart.order', JSON.stringify(this.itemsService.selectedOrderItems));
                            return false
                          } else {
                            return true
                          }
                        });
                      } else {
                        this.addToCart('order', product, item.orderqty);
                      }
                    }
                    // order items end
                    // autoship quantity items
                    if (item.autoshipqty > 0) {
                      if (item.itemoptionid > 0) {
                        product.OptionsMap.every(element => {
                          if (parseInt(element.ItemId) == parseInt(item.itemoptionid)) {
                            product.ItemID = element.ItemId;
                            const key = element.Key;
                            product.selectedOptions = '[' + key.replaceAll('|', ',') + ']';
                            this.addToCart('autoship', product, item.autoshipqty);
                            return false
                          } else {
                            return true
                          }
                        });
                      } else {
                        this.addToCart('autoship', product, item.autoshipqty);
                      }
                    }
                    // autoship items end
                  });
                });
                // membership item
                if (this.userService.userServiceModal.customerTypeID == 3) {
                  this.itemsForCustomerPC();
                } else if (this.userService.userServiceModal.customerTypeID == 1) {
                  this.itemsForCustomerIBO();
                }
                // membership item end
                // this.router.navigate(['home'], {
                //   queryParams: {},
                //   queryParamsHandling: 'merge',
                // });
                // const currentPath = this.router.routerState.snapshot.url;
                //   console.log(currentPath);
                this.sideNavBarService.triggerOpen();
              }
            }
            );
          }
          // })
          // snapshot if ends
        }
        if (!(event instanceof NavigationEnd)) {
          return;
        }
        try {
          let pathArray = event.urlAfterRedirects.split('/');
          let pageName = pathArray[pathArray.length - 1];
          var data = JSON.stringify({ "pageName": pageName, "pageURL": location.href });
          window['ZTM'].setStats('commonsense', 'PageView', data);
        } catch (error) {
        }
        // activation route end
      });
      // route subscribe ends
    } catch (error) {
      console.error("This error is from link builder integration")
    }
  }

  loginFunction(username?: string, password?: string, granttype?: string, returnUrl?: string | null) {
      sessionStorage.setItem('guestLogin', 'false');
      this.userService.clearCustomerData();
      sessionStorage.removeItem('guestLogin');

      const loginrequest = {
        granttype: granttype,
        scope: 'ecommerce',
        username: username,
        password: password
      };
      this.apiService.Login(loginrequest).subscribe(
        (result) => {
          if (result && result.status == 200 && result.body.Status != 1) {
            try {
              sessionStorage.setItem('isLoggedIn', 'true');
              this.accountService.getCustomerData(result.body.CustomerId).then((data: any) => {
                if (data && data.Data) {
                  sessionStorage.setItem('user', JSON.stringify(data.Data));
                  this.userService.userServiceModal.customerData = data.Data;
                  sessionStorage.setItem('userService', JSON.stringify(this.userService.userServiceModal));
                  this.userService.userServiceModal.customerTypeID = this.userService.userServiceModal.customerData.CustomerType;
                  if (this.previousType !== this.userService.userServiceModal.customerTypeID) {
                    this.userService.userServiceModal.couponInfo.Allcoupons = [];
                    this.autoshipConfigurationService.autoshipDate = '';
                    this.userService.userServiceModal.shippingMethods = [];
                    this.userService.userServiceModal.selectedShippingMethod = "";
                    this.autoshipConfigurationService.init();
                  }
                  sessionStorage.removeItem("cart.order");
                  sessionStorage.removeItem("cart.autoship");
                  sessionStorage.removeItem("cart.packs");
                  // Clean up old localStorage data
                  localStorage.removeItem("cart.order");
                  localStorage.removeItem("cart.autoship");
                  localStorage.removeItem("cart.packs");
                  this.cartsService.clearCart();
                  if (!this.utilityService.isEmptyObject(this.userService.userServiceModal.customerData.DefaultShippingAddress)) {
                    this.userService.setShippingAddress();
                  } else {
                    this.userService.userServiceModal.shippingAddress = new UserServiceModal().newshippingAddress;
                  }
  
                  if (this.userService.userServiceModal.customerData.WebAlias) {
                    this.apiService.validateWebAlias(this.userService.userServiceModal.customerData.WebAlias).subscribe((res: any) => {
                      if (res.Data) {
                        this.userService.userServiceModal.WebAlias = this.userService.userServiceModal.customerData.WebAlias;
                        this.loginredirect(this.userService.userServiceModal.WebAlias, returnUrl);
                      }else{
                        const customerName = this.userService.userServiceModal?.customerData?.FirstName || 'User'; 
                        this.notification.success('success_', `Welcome, ${customerName}!`);
                        // this.router.navigate(['/shop'])
                        // location.href = `${location.origin}/${this.userService.userServiceModal?.customerData?.WebAlias}/shop`;
                        this.redirectAfterLogin(this.userService.userServiceModal?.customerData?.WebAlias, returnUrl);
                      }
                    }, (error) => {
                      if (error.Data && !error.Data.WebAlias) {
                        this.notification.error('error_', 'webalias_not_exists');
                        return false;
                      }
                    },
                      () => {
  
                      });
                  }
                  else if (this.userService.userServiceModal.customerData.SponsorId) {
                    this.apiService.getSearchCustomerDetail(this.userService.userServiceModal.customerData.SponsorId).subscribe((resp: any) => {
                      if (resp.Data) {
                        this.apiService.validateWebAlias(resp.Data.WebAlias).subscribe((res: any) => {
                          if (res.Data) {
                            this.userService.userServiceModal.WebAlias = resp.Data.WebAlias;
                            const customerName = this.userService.userServiceModal?.customerData?.FirstName || 'User';
                            this.notification.success('success_', `Welcome, ${customerName}!`);
                            // location.href = `${location.origin}/${this.userService.userServiceModal.WebAlias}`;
                            this.redirectAfterLogin(this.userService.userServiceModal.WebAlias, returnUrl);
                          }
                        }, (error) => {
                          if (error.Data && !error.Data) {
                            this.notification.error('error_', 'webalias_not_exists');
                            return false;
                          }
                        },
                          () => {
  
                          });
                      }
                    }, (error) => {
                      if (error.Data && !error.Data.WebAlias) {
                        this.notification.error('error_', 'webalias_not_exists');
                        return false;
                      }
                    },
                      () => {
  
                      });
                  }
                } else {
                  this.notification.error('error_', 'error_occured_try_again');
                }
              }).catch((error) => {
                this.notification.error('error_', 'error_occured_try_again');
                console.error('ex', error);
              });
            } catch (successEx) {
              this.notification.error('error_', 'error_occured_try_again');
              console.error('ex', successEx);
            }
          } else {
            this.notification.error('error_', 'Authentication Failed');
          }
        }, err => {
          this.notification.error('error_', 'error_occured_try_again');
        },
        () => {
  
        });
    }
    private loginredirect(alias: string, returnUrl?: string | null) {
      const customerName = this.userService.userServiceModal?.customerData?.FirstName || 'User';
      this.notification.success('success_', `Welcome, ${customerName}!`);

      if (returnUrl && this.isValidReturnUrl(returnUrl)) {
        this.redirectAfterLogin(alias, returnUrl);
        return;
      }

      let newUrl = `${location.origin}/${alias}`;

      if (this.checkitem()) {
        this.userService.userServiceModal.checkItems = true;
        window.location.assign(`${newUrl}/checkout`);
      } else if (this.itemsService.selectedAutoOrderItems.length) {
        this.userService.userServiceModal.checkItems = true;
        window.location.assign(`${newUrl}/products/all`);
      } else {
        window.location.assign(`${newUrl}/products/all`);
       }
    }

  private redirectAfterLogin(webAlias: string, returnUrl?: string | null): void {
    const baseUrl = `${location.origin}/${webAlias}`;

    if (returnUrl && this.isValidReturnUrl(returnUrl)) {
      const pathWithoutAlias = this.stripWebAliasFromPath(returnUrl, webAlias);
      location.href = `${baseUrl}${pathWithoutAlias}`;
    } else {
      location.href = `${baseUrl}/shop`;
    }
  }

  private stripWebAliasFromPath(path: string, webAlias: string): string {
    const aliasPrefix = `/${webAlias}`;
    if (path.toLowerCase().startsWith(aliasPrefix.toLowerCase())) {
      return path.substring(aliasPrefix.length) || '/shop';
    }
    return path;
  }

  private isValidReturnUrl(url: string): boolean {
    if (!url) return false;
    if (url.startsWith('//')) return false;
    if (url.includes('://')) return false;
    if (url.toLowerCase().startsWith('javascript:')) return false;
    return true;
    }
         checkitem() {
       return (this.itemsService.selectedOrderItems.length > 0 || this.itemsService.selectedAutoOrderItems.length > 0);
     }

           /**
       * Check if current domain needs to be redirected to the new domain
       */
      private checkDomainRedirect(): void {
        const currentDomain = window.location.hostname;
        
        // Check if current domain contains the old domain (handles subdomains)
        if (currentDomain.includes('commonsenseww.com')) {
          // Get the current path and query parameters
          const currentPath = window.location.pathname;
          const currentSearch = window.location.search;
          const currentHash = window.location.hash;
          
          // Extract subdomain if it exists
          let subdomain = '';
          if (currentDomain !== 'commonsenseww.com' && currentDomain !== 'www.commonsenseww.com') {
            // Extract subdomain part (everything before 'commonsenseww.com')
            const domainParts = currentDomain.split('.');
            if (domainParts.length > 2) {
              // Remove 'www' if it's the first part and there are other subdomains
              if (domainParts[0] === 'www' && domainParts.length > 3) {
                subdomain = domainParts.slice(1, -2).join('.') + '.';
              } else if (domainParts[0] !== 'www') {
                subdomain = domainParts.slice(0, -2).join('.') + '.';
              }
            }
          }
          
          // Construct the new URL with subdomain preserved
          const newUrl = `https://${subdomain}commonsensewellness.com${currentPath}${currentSearch}${currentHash}`;
          
          // Store redirect info for analytics (optional)
          sessionStorage.setItem('domainRedirected', 'true');
          sessionStorage.setItem('redirectedFrom', currentDomain);
          
          // Redirect to the new domain
          window.location.href = newUrl;
        }
      }
}
